import { resource } from './client.ts';

const resourceObj = resource('users/my');
const { create: resetPassword } = resource('users/reset-password');
const { replace: changePassword } = resource('users/change-password');
const { get: getPermissions } = resource('users/my/permissions');

const { get: getUserData } = resourceObj;

export default getUserData;
export { changePassword, resetPassword, getPermissions };
